module.exports = __webpack_public_path__ + "static/media/1010.8b0b4453.jpg";